import * as React from 'react';
import { ArticleHeading2 } from '@cian/ui-kit';
import { Button } from '../Button';
import shrug from '../../../assets/shrug.png';
import * as styles from './FailureContent.css';
export var FailureContent = function FailureContent(_ref) {
  var onConfirm = _ref.onConfirm;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "failure-callback-content"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['image'],
    src: shrug
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['message']
  }, /*#__PURE__*/React.createElement(ArticleHeading2, {
    as: "p",
    textAlign: "center"
  }, "\u0423\u043F\u0441..., \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A")), /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437"));
};